interface ProductInquiry {
    brand_name?: string;
    name?: string;
    tire_size?: string;
}

interface TruckTireInquiry {
    Markasi?: string;
    MalzemeAdi?: string;
    MalzemeKodu?: string;
    UrunID?: number;
}

const WHATSAPP_NUMBER = '905441205454';

export const getProductInquiryWhatsAppUrl = (product: ProductInquiry, productUrl: string) => {
    const message = [
        'Merhaba, aşağıdaki lastik için fiyat ve stok bilgisi rica ediyorum.',
        `Marka: ${product.brand_name || '-'}`,
        `Ürün: ${product.name || '-'}`,
        `Ebat: ${product.tire_size || '-'}`,
        `Ürün bağlantısı: ${productUrl}`
    ].join('\n');

    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const getTruckTireInquiryWhatsAppUrl = (product: TruckTireInquiry, productUrl: string) => {
    const message = [
        'Merhaba, aşağıdaki kamyon lastiği için fiyat ve stok bilgisi rica ediyorum.',
        `Marka: ${product.Markasi || '-'}`,
        `Ürün: ${product.MalzemeAdi || '-'}`,
        `Ürün kodu: ${product.MalzemeKodu || '-'}`,
        `Ürün ID: ${product.UrunID || '-'}`,
        `Ürün bağlantısı: ${productUrl}`
    ].join('\n');

    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};
